/**
 * 会员分析统计
 * lixian
 */
const api = [
  {
    name: 'analysis',
    method: 'GET',
    desc: '企业分析top栏',
    path: '/analysis'
  },
  {
    name: 'transaction',
    method: 'GET',
    desc: '企业分析交易细分分析',
    path: '/analysis/transaction'
  },
  {
    name: 'turnover',
    method: 'GET',
    desc: '企业分析交易额',
    path: '/analysis/turnover'
  }
]

export default {
  BASE_URL: '/org',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/member/org-analysis.js